import { z } from 'zod/v4';

export const ssoUserSchema = z.object({
  id: z.number(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  alias: z.string().nullable(),
});

export type SsoUser = z.infer<typeof ssoUserSchema>;
